export {
  GetWalletReferralDetailsParams,
  GetWalletReferralDetailsResult,
  GetWalletReferralCodeParams,
  GetWalletReferralCodeResult,
} from '@reyaxyz/common';
